// extracted by mini-css-extract-plugin
export default {"root":"FeatureFlagCard_root__sY0JD","active":"FeatureFlagCard_active__fj+rE"};